module.exports = __webpack_public_path__ + "static/media/amazon_music.f9ca8d03.svg";